module.exports = __webpack_public_path__ + "img/eg-other-02.d4ae3015.png";